import { render, staticRenderFns } from "./DocumentoView.vue?vue&type=template&id=6cdde082&"
import script from "./DocumentoView.vue?vue&type=script&lang=js&"
export * from "./DocumentoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports